import * as React from "react";
import { forwardRef } from "react";
const SvgDoubleArrowBackward = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 16, viewBox: "0 0 23 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.75 14.25L8.25 15.75L16.125 7.875L8.25 0L6.75 1.5L12.0029 6.75293H0V9.00293H11.9971L6.75 14.25Z", fill: "#89A6FF" }), /* @__PURE__ */ React.createElement("path", { d: "M19.875 7.875L13.5 14.25L15 15.75L22.875 7.875L15 0L13.5 1.5L19.875 7.875Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgDoubleArrowBackward);
export { ForwardRef as ReactComponent };
